<template>
    <div>
        <s-crud
            title="Selladoras MTV"
            ref="gridpackinglines"
            excel
            edit
            add
            @save="save($event)"
            :filter="filter"
            sorteable
            remove
            :config="config"
            search-input
            >
            <template v-slot="props">
                <v-container>
                    <v-row >
                        <v-col cols="3" lg="3" md="6" sm="12">
                            <s-text label="Descripcion"
                            v-model="props.item.PsbDescription"
                            ref="PsbDescription"></s-text>
                        </v-col>
                        <v-col cols="3" lg="3" md="6" sm="12">
                            <s-select 
                                :items="ItemsLinesOut"
                                label="Faja de Salida"                                
								item-value="PloID"                                
								item-text="PloDescription"
                                v-model="props.item.PloID">
                            </s-select>
                        </v-col>
                        <v-col cols="3" lg="3" md="6" sm="12"> 
                            <s-select-definition                                 
                                :def=1154 label="Estado" 
                                v-model=props.item.PsbStatus>
                            </s-select-definition>  
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template v-slot:PsbStatus="{row}">
                <v-icon :color="row.PsbStatus == 1 ? 'success': 'default'">mdi-checkbox-blank-circle</v-icon>
            </template>
        </s-crud>
    </div>
</template>


<script>

    import _sPackingSealersBag from '@/services/FrozenProduction/FrzPackingSealersBag.js'
    import _sFrzTypeExitCategoryService from "@/services/FrozenProduction/FrzLinesPackingOut.js"
    export default
    {
        data: () => {
            return{
                ItemsLinesOut: [],
                filter: {},
                config:{                    
                    service : _sPackingSealersBag,
                    headers: [                            
                        {text: "ID", value: "PsbID",  align: "center", width: "10%", sortable: true},
                        {text: "Descripcion", value: "PsbDescription",  align: "center", width: "80"},   
                        {text: "Faja de Salida", value: "PloDescription",  align: "center", width: "30"},                     
                        {text: "Estado", value: "PsbStatus",  align: "center", width: "30"},                        
                    ],
                    model:{
                        PsbID:"ID",
                        PsbStatus: "PsbStatus",
                    },
                }
            }
        },
        methods: {
        
            save(item)
            {                  
                if(item.PsbDescription == ""){
                    this.$fun.alert("Ingrese descripcion", "warning");
                    this.$refs.PsbDescription.focus();
                    return;
                }        
                item.UsrID = this.$fun.getUserID();         
                item.save();
            },
            initialize()
            {
                _sFrzTypeExitCategoryService.list({}, this.$fun.getUserID()).then(r =>{
                    if(r.status == 200)
                    {
                        this.ItemsLinesOut = r.data;                    
                    }
                });            
            }
        },
        created()
        {
            this.initialize()
        },
        
    }
</script>